module.exports = __webpack_public_path__ + "img/p3-3.e27643d3.png";